"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6406],{

/***/ 6406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7 3h10.6c2.1 0 3.7 1.6 3.8 3.7v10.7c0 2.1-1.7 3.7-3.7 3.7H6.7c-2.1 0-3.7-1.7-3.7-3.7V6.7C3 4.6 4.6 3 6.7 3zm10.6 16c1 0 1.7-.8 1.7-1.7V6.7c0-1-.7-1.7-1.6-1.7H6.7C5.7 5 5 5.7 5 6.7v10.6c0 1 .7 1.7 1.7 1.7h10.6zm-3.8-7a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm1.5-1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM10.5 15a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
}), "Casino"));


/***/ })

}]);